import React from "react";

const AnalyticsSkeleton = () => {
  return (
    <div className="w-full">
      {/* Dropdown Skeleton */}
      <div className="flex justify-between items-center mb-4">
        <div className="w-[180px] h-10 bg-gray-200 rounded-md animate-pulse" />
      </div>

      {/* Title Skeleton */}
      <div className="w-[60%] sm:w-[40%] h-8 bg-gray-200 rounded-md mb-3 mt-2 animate-pulse" />

      {/* Score Card Skeleton */}
      <div className="w-full bg-gray-200 rounded-lg h-[200px] sm:h-[250px] mb-6 animate-pulse" />

      {/* Sectional Summary Title */}
      <div className="mb-3">
        <div className="w-[50%] sm:w-[30%] h-7 bg-gray-200 rounded-md mb-2 animate-pulse" />
        <div className="w-[80%] sm:w-[60%] h-4 bg-gray-200 rounded-md animate-pulse" />
      </div>

      {/* Two Section Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {[1, 2].map((i) => (
          <div
            key={i}
            className="bg-gray-200 rounded-lg h-[280px] sm:h-[320px] animate-pulse"
          />
        ))}
      </div>

      {/* Question-wise Analysis Section */}
      <div className="mt-8 mb-4">
        <div className="w-[50%] sm:w-[35%] h-7 bg-gray-200 rounded-md mb-4 animate-pulse" />
        
        {/* Tabs Skeleton */}
        <div className="flex gap-2 border-b border-gray-200 mb-4">
          {[1, 2].map((i) => (
            <div
              key={i}
              className="w-[100px] sm:w-[140px] h-10 bg-gray-200 rounded-t-md animate-pulse"
            />
          ))}
        </div>

        {/* Question Cards Skeleton */}
        <div className="space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="w-full h-[120px] sm:h-[140px] bg-gray-200 rounded-lg animate-pulse"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsSkeleton;